// Most typed confirmations ignore spaces around the phrase.
// strictWhitespace rejects those spaces.
// allowTrailingPeriod also accepts one period at the end of the phrase.
function typedConfirmationMatches(typedText, expected, options) {
    if (typedText == null || expected == null) {
        return false;
    }

    var expectedLower = String(expected).toLowerCase();
    if (options && options.strictWhitespace) {
        var value = String(typedText).toLowerCase();
        if (value === expectedLower) {
            return true;
        }
        if (options.allowTrailingPeriod && value === expectedLower + '.') {
            return true;
        }
        return false;
    }

    return String(typedText).trim().toLowerCase() === expectedLower;
}

function ShowConfirmationModal(message, callback, typedConfirmMessage, showTypedMessage, additionalModalId, confirmText, dismissText, dismissCallback, style, secondaryMessage) {
    var typedMatchOptions = null;
    if (typedConfirmMessage && typeof typedConfirmMessage === 'object') {
        typedMatchOptions = typedConfirmMessage;
        typedConfirmMessage = typedConfirmMessage.text;
    }

    style = style || 'warning';

    var iconClass1 = style == 'info' ? 'icon guidance' : 'icon';
    var iconClass2 = style == 'info' ? 'fa-solid fa-info' : 'novicon novicon-exclamation';

    var modalID = "confirm-modal" + additionalModalId;
    var deleteModal = parent.$("#" + modalID);
    if (deleteModal.length === 0) {
        parent.$("body").append('<div class="modal fade no-header alert-modal" id="' + modalID + '" tabindex="-1" role="dialog" aria-hidden="true"><div class="modal-dialog" style="' + style +  '"><div class="modal-content"><div class="modal-body"></div></div></div></div>');
        deleteModal = parent.$("#" + modalID);
    }
    if (parent.$(".modal:visible").length > 0) {
        deleteModal.css("z-index", parseInt(parent.$(".modal:visible").css("z-index")) + 2);
    }
    var modalBody = deleteModal.find('.modal-body');

    if (!confirmText || confirmText.length == 0)
        confirmText = 'Yes';

    if (!dismissText || dismissText.length == 0)
        dismissText = 'No';

    if (typedConfirmMessage) {
        var htmlText = [
            '<div class="message-container">',
            `   <span class="${iconClass1}"><span class="${iconClass2}" role="img" aria-label="warning"></span></span>`,
            '   <div class="message" style="padding-bottom: 5px;">',
            '       <p>',
            message,
            '       </p>' +
            '       <p>',
            '           <em>', showTypedMessage === true ? typedConfirmMessage : '', '</em>',
            '       </p>',
            '   </div>',
            '   <div class="form-group">',
            '       <textarea class="form-control" id="confirm-text"></textarea>',
            '   </div>',
            '</div>'
        ].join('');
        var buttonText = [
            '<div class="buttons clearfix">',
            '   <a href="javascript:void(0);" class="btn btn-default" data-dismiss="modal" id="do-dismissed-action">' + dismissText + '</a>',
            '   <a href="javascript:void(0);" class="btn btn-primary" id="do-confirmed-action">' + confirmText + '</a>',
            '</div>'
        ].join('');
        modalBody.html(htmlText);
        modalBody.append(buttonText);
    }
    else if (message && secondaryMessage) {
        modalBody.html(`<div class="message-container"><span class="${iconClass1}"><span class="${iconClass2}"></span></span><div class="message one-line"><strong>${message}</strong></br></br>${secondaryMessage}</div></div>`);
        modalBody.append('<div class="buttons clearfix"><a href="javascript:void(0);" class="btn btn-default" data-dismiss="modal" id="do-dismissed-action">' + dismissText + '</a><a href="javascript:void(0);" class="btn btn-primary" data-dismiss="modal" id="do-confirmed-action">' + confirmText + '</a></div>');
    }
    else {
        modalBody.html(`<div class="message-container"><span class="${iconClass1}"><span class="${iconClass2}"></span></span><div class="message one-line">${message}</div></div>`);
        modalBody.append('<div class="buttons clearfix"><a href="javascript:void(0);" class="btn btn-default" data-dismiss="modal" id="do-dismissed-action">' + dismissText + '</a><a href="javascript:void(0);" class="btn btn-primary" data-dismiss="modal" id="do-confirmed-action">' + confirmText + '</a></div>');        
    }

    deleteModal.modal({
        backdrop: "static",
        keyboard: false
    });

    if (typedConfirmMessage) {
        $(modalBody).find("#do-confirmed-action").attr('disabled', true);

        $(modalBody).find("#confirm-text").on('keyup',
            function (evt) {
                var typedText = $(evt.target)[0].value;

                if (typedConfirmationMatches(typedText, typedConfirmMessage, typedMatchOptions)) {
                    $(modalBody).find("#do-confirmed-action").attr('disabled', false);
                }
                else {
                    $(modalBody).find("#do-confirmed-action").attr('disabled', true);
                }
            });
    }

    // YES click event
    $(modalBody).find("#do-confirmed-action").click(function (evt) {
        var typedText;

        // If we require a typed confirmation message then we need to validate that the user has correctly typed it
        if (typedConfirmMessage) {
            // Get the text that the user typed
            typedText = $(modalBody).find("#confirm-text")[0].value;

            // See if it matches the required confirmation message
            if (typedConfirmationMatches(typedText, typedConfirmMessage, typedMatchOptions) && callback) {
                deleteModal.modal('hide');
                callback();
            }
        }
        else if (callback) {
            deleteModal.modal('hide');
            callback();
        }
    });

    // NO click event
    $(modalBody).find("#do-dismissed-action").click(function (evt) {
        if (dismissCallback) {
            deleteModal.modal('hide');
            dismissCallback();
        }
    });

    deleteModal.modal();

    if (parent.$(".modal:visible").length > 0) {
        deleteModal.css("z-index", parseInt(parent.$(".modal:visible").css("z-index")) + 2);
        parent.$(".modal-backdrop:last").css("z-index", parseInt(parent.$(".modal:visible").css("z-index")) + 1);
    }

    return false;
}

/**
 * Same visual shell as ShowConfirmationModal, with a titled question and radio choices.
 * @param {string} message Prompt shown beside the icon (e.g. "What are you trying to accomplish?")
 * @param {Array<{ label: string, callback: function }>} options Each item: label text and callback when user clicks Continue with that option selected.
 * @param {string} [additionalModalId] Optional suffix so multiple modals don't share the same DOM id.
 * @param {string} [confirmText] Primary button label (default "Continue").
 * @param {string} [dismissText] Secondary button label (default "Cancel").
 * @param {function} [dismissCallback] Invoked when the user clicks the dismiss button (after the modal hides).
 * @param {string} [style] Same as ShowConfirmationModal: 'warning' (default) or 'info'.
 */
function ShowRadioChoiceModal(message, options, additionalModalId, confirmText, dismissText, dismissCallback, style) {
    if (!parent.jQuery || !options || !options.length) {
        return false;
    }

    additionalModalId = additionalModalId || '';
    style = style || 'warning';

    // Magenta #A32763 (same as .icon.guidance) — not warning red.
    var iconClass1 = 'icon guidance radio-choice-modal__icon';
    var iconClass2 = style == 'info' ? 'fa-solid fa-info' : 'novicon novicon-exclamation';

    var modalID = 'radio-choice-modal' + additionalModalId;
    var choiceModal = parent.$('#' + modalID);
    if (choiceModal.length === 0) {
        parent.$('body').append('<div class="modal fade no-header alert-modal" id="' + modalID + '" tabindex="-1" role="dialog" aria-hidden="true"><div class="modal-dialog" style="' + style + '"><div class="modal-content"><div class="modal-body"></div></div></div></div>');
        choiceModal = parent.$('#' + modalID);
    }
    if (parent.$('.modal:visible').length > 0) {
        choiceModal.css('z-index', parseInt(parent.$('.modal:visible').css('z-index')) + 2);
    }

    if (!confirmText || confirmText.length == 0) {
        confirmText = 'Continue';
    }
    if (!dismissText || dismissText.length == 0) {
        dismissText = 'Cancel';
    }

    var questionElId = modalID.replace(/\s+/g, '-') + '-question';
    var groupName = 'radio-choice-modal-group-' + modalID.replace(/\W/g, '');

    var radioBlocks = [];
    for (var o = 0; o < options.length; o++) {
        var optId = modalID + '-opt-' + o;
        var labelText = parent.$('<div/>').text(options[o].label == null ? '' : options[o].label).html();
        var checked = o === 0 ? ' checked' : '';
        radioBlocks.push(
            '<div class="radio">' +
            '  <label for="' + optId + '">' +
            '    <input type="radio" name="' + groupName + '" id="' + optId + '" value="' + o + '"' + checked + '> ' +
            labelText +
            '  </label>' +
            '</div>'
        );
    }

    var htmlText = [
        '<div class="message-container radio-choice-modal">',
        '  <div class="radio-choice-modal-row">',
        '    <span class="' + iconClass1 + '"><span class="' + iconClass2 + '" role="img" aria-label="warning"></span></span>',
        '    <div class="radio-choice-modal-content">',
        '      <div class="radio-choice-modal__title message">',
        '        <p id="' + questionElId + '" class="radio-choice-modal__question"><strong>',
        message,
        '        </strong></p>',
        '      </div>',
        '      <div class="radio-choice-modal-options form-group" role="radiogroup" aria-labelledby="' + questionElId + '">',
        radioBlocks.join(''),
        '      </div>',
        '    </div>',
        '  </div>',
        '</div>'
    ].join('');

    var buttonText = [
        '<div class="buttons clearfix">',
        '  <a href="javascript:void(0);" class="btn btn-default" data-dismiss="modal" id="do-dismissed-action">' + dismissText + '</a>',
        '  <a href="javascript:void(0);" class="btn btn-primary" id="do-confirmed-action">' + confirmText + '</a>',
        '</div>'
    ].join('');

    var modalBody = choiceModal.find('.modal-body');
    modalBody.html(htmlText);
    modalBody.append(buttonText);

    choiceModal.modal({
        backdrop: 'static',
        keyboard: false
    });

    $(modalBody).find('#do-confirmed-action').click(function () {
        var selected = $(modalBody).find('input[name="' + groupName + '"]:checked');
        if (!selected.length) {
            return;
        }
        var idx = parseInt(selected.val(), 10);
        var opt = options[idx];
        if (opt && typeof opt.callback === 'function') {
            choiceModal.modal('hide');
            opt.callback();
        }
    });

    $(modalBody).find('#do-dismissed-action').click(function () {
        if (dismissCallback) {
            dismissCallback();
        }
    });

    choiceModal.modal();

    if (parent.$('.modal:visible').length > 0) {
        choiceModal.css('z-index', parseInt(parent.$('.modal:visible').css('z-index')) + 2);
        parent.$('.modal-backdrop:last').css('z-index', parseInt(parent.$('.modal:visible').css('z-index')) + 1);
    }

    return false;
}

function RecordsNounForCount(count) {
    return Number(count) === 1 ? "record" : "records";
}

function ShowCustomAlertWithReturnTargetFocus(message, target) {
    ShowCustomAlert(message, function () {
        $($(target)).focus();
    });
}

/**
 * Same chrome as ShowCustomAlert but green success styling and checkmark icon.
 * @param {string} titleText Shown in bold at the top (escaped as plain text).
 * @param {string} bodyText Body copy below the title (escaped as plain text).
 * @param {function} [callback] Called when the modal is dismissed.
 * @param {string} [buttonLabel] Primary button text (default "OK").
 */
function ShowSuccessAlert(titleText, bodyText, callback, buttonLabel) {
    if (!parent.jQuery) {
        return false;
    }

    buttonLabel = buttonLabel && buttonLabel.length ? buttonLabel : 'OK';

    var titleEsc = parent.$('<div/>').text(titleText == null ? '' : titleText).html();
    var bodyEsc = parent.$('<div/>').text(bodyText == null ? '' : bodyText).html();

    var modalID = 'custom-success-alert';
    var alertModal = parent.$('#' + modalID);
    if (alertModal.length == 0) {
        parent.$('body').append('<div class="modal fade no-header alert-modal alert-modal-success" id="' + modalID + '" tabindex="-1" role="dialog" aria-hidden="true"><div class="modal-dialog"><div class="modal-content"><div class="modal-body"></div></div></div></div>');
        alertModal = parent.$('#' + modalID);
    }
    var inAnotherModal = parent.$('.modal:visible').length > 0;
    var otherModalZIndex = 0;
    if (inAnotherModal) {
        otherModalZIndex = parseInt(parent.$('.modal:visible').css('z-index'));
        alertModal.css('z-index', otherModalZIndex + 2);
    }

    var modalBody = alertModal.find('.modal-body');
    modalBody.html(
        '<div class="message-container">' +
        '<span class="icon success"><span class="fa-solid fa-check" role="img" aria-label="success"></span></span>' +
        '<div class="message">' +
        '<p class="alert-success-modal__title"><strong>' + titleEsc + '</strong></p>' +
        '<p class="alert-success-modal__body">' + bodyEsc + '</p>' +
        '</div></div>'
    );
    modalBody.append('<div class="buttons clearfix"><a href="javascript:void(0);" class="btn btn-default" data-dismiss="modal">' + parent.$('<div/>').text(buttonLabel).html() + '</a></div>');

    alertModal.off('hidden.bs.modal.successAlert').on('hidden.bs.modal.successAlert', function () {
        if (typeof callback === 'function') {
            callback();
        }
    });
    alertModal.modal({
        backdrop: 'static',
        keyboard: false
    });
    if (inAnotherModal) {
        parent.$('.modal-backdrop:last').css('z-index', otherModalZIndex + 1);
    }
    return false;
}

function ShowCustomAlert(message, callback, customButtonHtml, icon, iconContainerClass) {
    if (parent.jQuery) {
        var modalID = "custom-alert";
        var alertModal = parent.$("#" + modalID);
        if (alertModal.length == 0) {
            parent.$("body").append('<div class="modal fade no-header alert-modal" id="' + modalID + '" tabindex="-1" role="dialog" aria-hidden="true"><div class="modal-dialog"><div class="modal-content"><div class="modal-body"></div></div></div></div>');
            alertModal = parent.$("#" + modalID);
        }
        var inAnotherModal = parent.$(".modal:visible").length > 0;
        var otherModalZIndex = 0;
        if (inAnotherModal) {
            otherModalZIndex = parseInt(parent.$(".modal:visible").css("z-index"));
            alertModal.css("z-index", otherModalZIndex + 2);
        }

        icon = icon || 'novicon novicon-exclamation';

        if (typeof iconContainerClass == "undefined" || iconContainerClass == null) {
            iconContainerClass = "";
        }

        var modalBody = alertModal.find('.modal-body');
        modalBody.html('<div class="message-container"><span class="icon ' + iconContainerClass + '"><span class="' + icon + '" role="img" aria-label="warning"></span></span><div class="message">' + message + '</div></div>');
        modalBody.append('<div class="buttons clearfix"><a href="javascript:void(0);" class="btn btn-default" data-dismiss="modal">OK</a></div>');

        if (customButtonHtml) {
            modalBody.find(".buttons").prepend(customButtonHtml)
        }

        alertModal.on('hidden.bs.modal',
            function (e) {
                if (typeof callback === 'function')
                    callback();
            });
        alertModal.modal({
            backdrop: "static",
            keyboard: false
        });
        if (inAnotherModal) {
            parent.$(".modal-backdrop:last").css("z-index", otherModalZIndex + 1);
        }
        return false;
    }
}

function ShowRenameModal(fileName, callback) {

    var iconClass1 = 'icon';
    var iconClass2 = 'novicon novicon-exclamation';

    var modalID = "confirm-modal";
    var deleteModal = parent.$("#" + modalID);
    if (deleteModal.length === 0) {
        parent.$("body").append('<div class="modal fade no-header alert-modal" id="' + modalID + '" tabindex="-1" role="dialog" aria-hidden="true"><div class="modal-dialog"><div class="modal-content"><div class="modal-body"></div></div></div></div>');
        deleteModal = parent.$("#" + modalID);
    }
    if (parent.$(".modal:visible").length > 0) {
        deleteModal.css("z-index", parseInt(parent.$(".modal:visible").css("z-index")) + 2);
    }
    var modalBody = deleteModal.find('.modal-body');

    var confirmText = 'Rename';
    var dismissText = 'Cancel';
    var message = `Rename ${fileName}`;

    var fileType = fileName.split('.').pop();

    var htmlText = [
        '<div class="message-container">',
        `   <span class="${iconClass1}"><span class="${iconClass2}" role="img" aria-label="warning"></span></span>`,
        '   <div class="message" style="padding-bottom: 5px;">',
        '       <p style="margin-top: 8px;">',
        message,
        '       </p>' +
        '       <p>',
        '           <em>', '', '</em>',
        '       </p>',
        '   </div>',
        '   <div>',
        `       <span style="display: inline-flex; align-items: center; margin-top: 15px;">
                    <input type="text" class="form-control" id="confirm-text" style="display: inline-block; width: 275px;" maxlength="250" />
                    .${fileType}
                </span>`,
        '       <span style="margin-top: 10px;" class="text-danger error-message"></span>',
        '   </div>',
        '</div>'
    ].join('');
    var buttonText = [
        '<div class="buttons clearfix">',
        '   <a href="javascript:void(0);" class="btn btn-default" data-dismiss="modal" id="do-dismissed-action">' + dismissText + '</a>',
        '   <a href="javascript:void(0);" class="btn btn-primary" id="do-confirmed-action">' + confirmText + '</a>',
        '</div>'
    ].join('');
    modalBody.html(htmlText);
    modalBody.append(buttonText);

    deleteModal.modal({
        backdrop: "static",
        keyboard: false
    });

    $(modalBody).find("#do-confirmed-action").click(function (evt) {
        $(".error-message").text('');
        var typedText;
        typedText = $(modalBody).find("#confirm-text")[0].value;
        if (typedText.length) {
            let specialCharacters = /[<>:"/\\|?*\0]|^\s|\s$|\.$/;
            if (specialCharacters.test(typedText)) {
                $(".error-message").html("<br /> <br />File name contains invalid characters.");
            } else {
                deleteModal.modal('hide');
                callback(typedText);
            }
        } else {
            $(".error-message").html("<br /> <br />You must enter a new file name.");
        }
    });

    deleteModal.modal();

    if (parent.$(".modal:visible").length > 0) {
        deleteModal.css("z-index", parseInt(parent.$(".modal:visible").css("z-index")) + 2);
        parent.$(".modal-backdrop:last").css("z-index", parseInt(parent.$(".modal:visible").css("z-index")) + 1);
    }

    return false;
}